export enum filtersEnum {
  "user" = "user",
  "client" = "client",
  "contacts" = "contacts",
  "sector" = "sector",
}
